var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('Link',{attrs:{"link":_vm.link,"text":_vm.text}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }